// 本体の既存階層はコンフリクト対策で移動しない.新しいファイルを追加する場合もそちらへ.
// TODO: 将来的にはできれば移行を検討する事.
export * from "../../../../../infrastructure/format/ver2";
